<template>
  <b-card>
    <validation-observer v-slot="{ invalid }">
      <b-form>
        <b-row>
          <EntityEditSection
            :entity="entity"
            :form-fields="fields"
            module=""
            allow-autofocus
          />
          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-0 mr-1"
              :disabled="invalid"
              @click.prevent="submitForm"
            >
              {{ $t('Save Changes') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="reset"
              class="mt-0"
              variant="outline-secondary"
              @click.prevent="reloadData"
            >
              {{ $t('Reset') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BRow, BCol, BCard,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import EntityEditSection from '@/layouts/entity/EntityEditSection.vue'

export default {
  components: {
    BButton,
    BForm,
    BRow,
    BCol,
    BCard,
    ValidationObserver,
    EntityEditSection
  },
  directives: {
    Ripple,
  },
  props: {
    userData: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      entity: JSON.parse(JSON.stringify(this.userData)),
    }
  },
  computed: {
    fields() {
      return [
        {
          id: 'orcid',
          noParent: true,
          noUrl: true,
          label: this.$t('orcid'),
        },
        {
          id: 'escId',
          noParent: true,
          noUrl: true,
          label: this.$t('escId'),
        },
        {
          id: 'google',
          label: 'Google',
        },
        {
          id: 'facebook',
          label: 'Facebook',
        },
        {
          id: 'instagram',
          label: 'Instagram',
        },
        {
          id: 'linkedIn',
          label: 'LinkedIn',
        },
        {
          id: 'twitter',
          label: 'Twitter',
        },
        {
          id: 'pinterest',
          label: 'Pinterest',
        },
        {
          id: 'youtube',
          label: 'Youtube',
        },
      ].map(field => ({
        ...field,
        type: field.type || 'text',
        parent: field.noParent ? null : 'participant',
        class: 'mt-0',
        required: false,
        rules: field.noUrl ? null : 'url',
        colSize: field.colSize || 6,
      }))
    },
  },
  methods: {
    reloadData() {
      this.entity = JSON.parse(JSON.stringify(this.userData))
    },

    submitForm() {
      this.$emit('formSubmitted', {
        ...this.entity,
      })
    },
  },
}
</script>
